module.exports = __webpack_public_path__ + "static/baltimore-3cf287dfd0177c1810cc8aa1ca6e9b61.png";